module.exports = __webpack_public_path__ + "img/light-mud-decal-10.e0843b31.png";